import React from "react";
import classNames from "classnames";

const defaultProps = {
  tag: "div"
};

const Header = ({ children, className, tag: Tag, ...rest }) => (
  <Tag className={classNames("header", className) + ' mb-2 mt-0'} {...rest}>
    {children}
  </Tag>
);

Header.defaultProps = defaultProps;

export default Header;
